import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.benutzer-telefon-aktualisieren-admin';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerTelefonAktualisierenAdminEffects {

    BenutzerTelefonAktualisierenAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BENUTZER_TELEFON_AKTUALISIEREN_ADMIN),
        mergeMap((x: ac.PostBenutzerTelefonAktualisierenAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBenutzerTelefonAktualisierenAdmin(x.benutzerTelefonRequest).pipe(
                map((result: any) => {
                    return new ac.PostBenutzerTelefonAktualisierenAdminErfolgreichAction(result, x.benutzerTelefonRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBenutzerTelefonAktualisierenAdminFehlerAction(error, x.benutzerTelefonRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungAdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungAdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungAdminCommandService);
        }
        return this.service;
    }
}
